import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { formatMoney, parseMoney, parserMoney, postRequest } from "../../../Utils/Functions";
import { useEffect, useState } from "react";

const PRICE_FRAGMENT = new FragmentDefiner(
	"Property",
	`
  price {
    amount
	currency {
		name
	}
  }
`
);

const ITAU_SERVICE = "https://prod.infocasas.com.uy/microservices/simulador/?/itau/simulation";
const ITAU_GET_VALUES =
	"https://prod.infocasas.com.uy/microservices/simulador/?/itau/getValuesProperty/";

export const useItauFinancing = ({ id, source }) => {
	const { data: propertyData } = useReadFragment(PRICE_FRAGMENT, id);
	const [loan, setLoan] = useState(0);
	const [propertyPrice, setPropertyPrice] = useState(0);
	const [propertyCurrency, setPropertyCurrency] = useState(undefined)
	const [years, setYears] = useState(10);
	const [type, setType] = useState(undefined);
	const [asset, setAsset] = useState(undefined);
	const [assetOptions, setAssetOptions] = useState([]);
	const [payment, setPayment] = useState(0);
	const [loading, setLoading] = useState(true);
	const [extraData, setExtraData] = useState(null);
	const [show, setShow] = useState(true);
	const [matchedYears, setMatchedYears] = useState([]);
	const [isDefaultSimulation, setIsDefaultSimulation] = useState(true);
	let timer = null;

	const ASSETS = [
		{
			value: "afd",
			text: "AFD",
			disabled: false
		},
		{
			value: "fondos_propios",
			text: "Fondos propios",
			disabled: false
		},
	];

	const TYPES = [
		{
			value: "compra",
			text: "Compra",
		},
		{
			value: "refaccion",
			text: "Refacción",
		},
		{
			value: "primera",
			text: "Mi primera vivienda",
		},
		{
			value: "construccion",
			text: "Construcción",
		},
		{
			value: "firma",
			text: "A sola firma",
		},
	];

	const firstYearsOptions = Array.from(Array(5), (e,i)=>i+1);
	const secondYearsOptions = Array.from(Array(10), (e,i)=>i+1);
	const thirdYearsOptions = Array.from(Array(15), (e,i)=>i+1);
	const fourthYearsOptions = Array.from(Array(27), (e,i)=>i+1);

	const YEARS = matchedYears.map(year => ({
		value: year,
		text: `${year} año${year > 1 ? "s" : ""}`,
	}));

	useEffect(() => {

	}, [])

	useEffect(() => {
		setAssetOptions(ASSETS);

		if (type === "primera") {
			setAssetOptions(
				assetOptions.map(item => 
					item.value === "fondos_propios"
					? {...item, disabled: true} 
					: item 
				)
			)
		}

		if (
			(type === "primera" ||
			type === "compra" ||
			type === "construccion" ||
			type === "refaccion" ||
			type === "firma"
			) && asset === "afd"
		) {
			setMatchedYears(fourthYearsOptions)
			setYears(fourthYearsOptions[fourthYearsOptions.length - 1])
		} else if (
			(
				type === "compra" ||
				type === "construccion" ||
				type === "refaccion"
			) && asset === "fondos_propios"
		) {
			setMatchedYears(thirdYearsOptions)
			setYears(thirdYearsOptions[thirdYearsOptions.length - 1])
		} else if (type === "firma"&& asset === "fondos_propios") {
			setMatchedYears(firstYearsOptions)
			setYears(firstYearsOptions[firstYearsOptions.length - 1])
		}
	}, [type, asset])

	useEffect(() => {
		if (propertyData) {
			setPropertyPrice(propertyData.price.amount);
			setPropertyCurrency(propertyData.price.currency.name)
		}
	}, [propertyData]);

	useEffect(() => {
		const getValues = async () => {
			try {
				const response = await fetch(`${ITAU_GET_VALUES}${propertyPrice}/${propertyCurrency === "U$S" ? 1 : 3}/0`);
				const data = await response.json();
	
				if (data) {
					setPropertyPrice(parserMoney(propertyPrice));
					setLoan(parserMoney(data.monto_solicitado));
					setYears(data.plazo / 12);
					setType(data.destino);
					setAsset(data.financiacion);
					setPayment(parserMoney(data.monto_cuotas));
					setIsDefaultSimulation(true);
				}
			} catch {
				return;
			}
		};

		if (propertyPrice > 0) {
			getValues();
		}
	}, [propertyPrice]);

	const itauService = async () => {
		setLoading(true);
		const data = await postRequest(ITAU_SERVICE, {
			monto: loan,
			destino: type,
			plazo: years * 12,
			financiacion: asset,
			currency: propertyCurrency === "U$S" ? 1 : 3,
		});

		if (data) {
			setPayment(data.data.monto_cuotas);
			setExtraData(data);
			setLoading(false);
			return data;
		}
	};

	useEffect(() => {
		if (loan > 0 && !isDefaultSimulation) {
			clearTimeout(timer);
			timer = setTimeout(() => {
				itauService();
			}, 600);
		}

		return () => clearTimeout(timer);
	}, [loan, years, type, asset]);

	return {
		loan: {
			amount: loan,
			change: setLoan,
		},
		property: {
			amount: propertyPrice,
		},
		years: {
			totalYears: YEARS,
			value: years,
			change: setYears,
		},
		type: {
			options: TYPES,
			value: type,
			change: setType,
		},
		asset: {
			options: assetOptions,
			value: asset,
			change: setAsset,
		},
		setIsDefaultSimulation,
		payment,
		propertyCurrency,
		extraData,
		show,
		itauService,
	};
};
